var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('a',{staticClass:"px-16 py-3 text-lg font-medium uppercase text-center border rounded-full",style:(_vm.styles),attrs:{"href":_vm.url}},[_vm._v("\n\t\t"+_vm._s(_vm.text)+"\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }